import { memo } from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const ArticleFill = memo((props: IconProps) => {
    const { color = "#000", ...rest } = props
    return (
        <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...rest}>
            <path
                fill={color}
                d="M13.333 14.667H2.667A.667.667 0 0 1 2 14V2a.667.667 0 0 1 .667-.667h10.666A.667.667 0 0 1 14 2v12a.667.667 0 0 1-.667.667ZM4.667 4v2.667h2.666V4H4.667Zm0 4v1.334h6.666V8H4.667Zm0 2.667V12h6.666v-1.333H4.667Zm4-6V6h2.666V4.667H8.667Z"
            />
        </svg>
    )
})

export default ArticleFill
